import React from 'react';
import { Image, StyleProp, View, ViewStyle } from 'react-native';
import { VideoViewer } from '@shared/components/VideoViewer';

const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'webp'];

const getFileExtension = (url: string): string | undefined => {
  const path = url.split(/[?#]/)[0];
  const match = path.match(/\.([a-zA-Z0-9]+)$/);
  return match?.[1]?.toLowerCase();
};

export const isImageMediaUrl = (url: string): boolean => IMAGE_EXTENSIONS.includes(getFileExtension(url) ?? '');

interface IMediaViewerProps {
  mediaUrl: string;
  style?: StyleProp<ViewStyle>;
  resizeMode?: 'contain' | 'cover' | 'stretch';
  controls?: boolean;
  paused?: boolean;
  repeat?: boolean;
}

export const MediaViewer: React.FC<IMediaViewerProps> = ({
  mediaUrl,
  style,
  resizeMode = 'contain',
  controls = true,
  paused = false,
  repeat = false,
}) => {
  const isImage = isImageMediaUrl(mediaUrl);

  if (isImage) {
    return (
      <View className="flex-1 bg-white" style={style}>
        <Image className="flex-1 w-full h-full" source={{ uri: mediaUrl }} resizeMode={resizeMode} />
      </View>
    );
  }

  return (
    <VideoViewer
      videoUrl={mediaUrl}
      style={style}
      resizeMode={resizeMode}
      controls={controls}
      paused={paused}
      repeat={repeat}
    />
  );
};
